import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'LoginModal',
};

import { computed, useStore } from '@nuxtjs/composition-api';
import LoginForm from '~/components/LoginForm.vue';
import ModalBase from '~/components/modals/ModalBase.vue';
import { State } from '~/store';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore<State>();

const close = async () => {
  try {
    await store.dispatch('toggleLoginModal', false);
  } catch (e) {
    console.error(e);
  }
};

const loggedIn = (success: boolean) => {
  if (success) {
    close();
  }
};
const show = computed(() => store.getters.showLoginModal);
const isErrorPage = computed(() => store.getters.isErrorPage);

return { __sfc: true,store, close, loggedIn, show, isErrorPage, LoginForm, ModalBase }
}

})